import { GET_PROJECTS_SUCCESS } from '../../constants/actions/project.constants';
import { IAction, IProject } from '../../types';
import { LOGOUT } from '../../constants/actions/auth.constants';

export default function (state: IProject[] = [], { payload, type }: IAction) {
    switch (type) {
        case GET_PROJECTS_SUCCESS:
            return payload;
        case LOGOUT:
            return [];
        default:
            return state;
    }
}
